export const circlesStyles = [
	// Instagram
	{
		width: 121,
		height: 121,

		left: 16,
		top: 0,
		animationName: 'bubble1-flow',
		animationDuration: '1s',
	},
	// Youtube
	{
		width: 79,
		height: 79,

		left: 158,
		top: 8,
		animationName: 'bubble2-flow',
		animationDuration: '1s',
	},
	// Tiktok
	{
		width: 85,
		height: 85,

		left: 246,
		top: 13,
		animationName: 'bubble3-flow',
		animationDuration: '1s',
	},
	// Snapchat
	{
		width: 98,
		height: 98,

		left: 16,
		top: 128,
		animationName: 'bubble4-flow',
		animationDuration: '1s',
	},
	// Facebook
	{
		width: 106,
		height: 106,

		left: 118,
		top: 94,
		animationName: 'bubble5-flow',
		animationDuration: '1s',
	},
	// Twitter
	{
		width: 100,
		height: 100,

		left: 232,
		top: 110,
		animationName: 'bubble6-flow',
		animationDuration: '1s',
	},
]
